export default {
  DEBUG: false,
  RESTLER_BACKEND_URL: 'https://db-api.dubbing-brothers.com',
  COOKIE_APP_DOMAIN: '.dubbing-brothers.com',
  COOKIE_SECURED: true,
  APP_ID: 25,
  DEFAULT_LANGUAGE: 'fr',
};
